<template>
    <div class="widget-inner">
        <h3 class="widget-title"><TranslatableStringComponent :tstring="{string: `${widgetTitle}`}" /></h3>
        <v-list class="mb-8" dense nav>
            <v-list-item-group v-model="item" color="primary">
                <v-list-item
                    v-for="(item, i) in items"
                    :key="`${type}-${i}`"
                    nuxt
                    :to="getCustomLocalePath(item)"
                >
                    <v-list-item-avatar>
                        <fa :icon="['fal', 'book-open']" class="fa-lg" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title
                            v-if="item.title && item.title[$i18n.locale]"
                            :to="
                                getStaticLocalePath({
                                    type: 'page',
                                    slugName: 'contact',
                                })
                            "
                        >
                            <strong>{{ item.title[$i18n.locale] }}</strong>
                        </v-list-item-title>
                        <v-list-item-subtitle
                            v-if="
                                item.seometa &&
                                item.seometa.metaDescription &&
                                item.seometa.metaDescription[$i18n.locale]
                            "
                            >{{ item.seometa.metaDescription[$i18n.locale] }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
        <SocialIcons v-if="type === 'joinUsOnline'" section="widget" />
    </div>
</template>
<script>
import postUtilities from '~/mixins/postUtilities'
import SocialIcons from '~/components/SocialIcons.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'Widget',
    components: {
        SocialIcons,
        TranslatableStringComponent,
    },
    mixins: [postUtilities],
    props: {
        items: {
            type: Array,
            default: null,
        },
        type: {
            type: String,
            default: 'recentPosts',
        },
    },
    data: () => ({
        item: null,
    }),
    computed: {
        widgetTitle() {
            return this.type
        },
    },
}
</script>
